import React from 'react';
import TestimonialStyled from "../../../styled/Testimonial";
import { Rating } from "@mui/material";
import AutoSlider from "../Slider/AutoSlider";
import { testimonialData } from './data';
import avatarImg from "../../../images/avatar.png";

const RenderTestimonialData = ({data})=>{
    const displayData = data && data.length > 0 ? data : testimonialData;

    const getTimeAgo = (createdAt) => {
        if (!createdAt) return '1';
        try {
            const date = new Date(createdAt.replace(' ', 'T'));
            const now = new Date();
            const diffInMs = now - date;
            const diffInWeeks = Math.floor(diffInMs / (1000 * 60 * 60 * 24 * 7));
            return diffInWeeks > 0 ? diffInWeeks : '1';
        } catch (e) {
            return '1';
        }
    };

    return (
        <AutoSlider speed={120}>
            {displayData.map((item,index)=>(
                <TestimonialStyled key={index}>
                    <div className="content">
                        <span>
                            <h3>{item.name}</h3>
                            <Rating name={`user-rating-${index}`} value={Number(item?.rating)} size="small" precision={0.5} readOnly />
                        </span>
                        <p>{item.comment || item.message}</p>
                        <p className="weeks">{item.time || getTimeAgo(item.createdAt)} weeks ago</p>
                    </div>
                    <div className="imageBox">
                        <img 
                            src={
                                item.profileImage && item.profileImage !== "/uploads/avatar.png" 
                                ? item.profileImage 
                                : (item.image || avatarImg)
                            } 
                            alt=""
                        />
                    </div>
                </TestimonialStyled>
            ))}
        </AutoSlider>
    );
}

export default RenderTestimonialData;
